import Gettext from "gettext.js";
import sk from "./locales/sk.json";
import en from "./locales/en.json";
import de from "./locales/de.json";
import cz from "./locales/cz.json";
import pl from "./locales/pl.json";
import pt from "./locales/pt.json";
import fr from "./locales/fr.json";
import es from "./locales/es.json";
import it from "./locales/it.json";

const savedLang = localStorage.getItem('lang');
if (!savedLang && window.acc_country && ['en', 'sk','cz', 'pl', 'de', 'es', 'pt', 'fr', 'it'].includes(window.acc_country.toLowerCase())) {
  localStorage.setItem('lang', window.acc_country.toLowerCase());
}
const i18n = new Gettext({
  domain: "messages",
  locale: (localStorage.getItem('lang') || 'en').toLowerCase()
});

i18n.setMessages("messages", "en", en, "nplurals=2; plural=(n != 1);");
i18n.setMessages("messages", "de", de, "nplurals=2; plural=(n != 1);");
i18n.setMessages("messages", "es", es, "nplurals=2; plural=(n != 1);");
i18n.setMessages("messages", "cz", cz, "nplurals=3; plural=(n==1) ? 0 : (n>=2 && n<=4) ? 1 : 2;");
i18n.setMessages("messages", "pl", pl, "nplurals=3; plural=(n==1 ? 0 : n%10>=2 && n%10<=4 && (n%100<10 || n%100>=20) ? 1 : 2);");
i18n.setMessages("messages", "pt", pt, "nplurals=2; plural=(n != 1);");
i18n.setMessages("messages", "fr", fr, "nplurals=2; plural=(n > 1);");
i18n.setMessages("messages", "sk", sk, "nplurals=3; plural=(n==1) ? 0 : (n>=2 && n<=4) ? 1 : 2;");
i18n.setMessages("messages", "it", it, "nplurals=2; plural=(n != 1);");

// expose helpers globally
window.gettext = (msgid) => i18n.gettext(msgid);

export default i18n;
